import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ecb980fa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ecb980fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb980fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb980fa')) {
      api.createRecord('ecb980fa', component.options)
    } else {
      api.reload('ecb980fa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ecb980fa&scoped=true&", function () {
      api.rerender('ecb980fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMDXg16ISGUz/JS/comp/PopupBox.vue"
export default component.exports